<template>
  <div id="chart-table-box">
    <chart-title leftTitle="MES入库实时监测">
      <el-button
        type="primary"
        slot="detail"
        size="mini"
        style="margin-right: 20px"
        >详 情</el-button
      >
    </chart-title>
    <div id="chart-table">
      <dv-scroll-board
        :config="config"
        style="width: 100%; height: 100%; margin-top: 10px"
      />
    </div>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
export default {
  mixins: [resize],
  name: "center_6",
  components: { ChartTitle },
  data() {
    return {
      config: {
        headerBGC: "transparent", // 表头背景色
        oddRowBGC: "transparent", // 奇数行背景色
        evenRowBGC: "transparent", // 偶数行背景色
        waitTime: 2000, // 轮播时间间隔(ms)
        align: [
          "center",
          "center",
          "center",
          "center",
          "center",
          "center",
          "center",
        ],
        columnWidth: [120],
        data: [
          [
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质列表</span>`,
            `<span style="color:#409EFF">已入库</span>`,
            `<span style="color:${this.getColor(-2)}">距交货-2天</span>`,
          ],
          [
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质列表</span>`,
            `<span style="color:#409EFF">已入库</span>`,
            `<span style="color:${this.getColor(0)}">距交货0天</span>`,
          ],
          [
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质列表</span>`,
            `<span style="color:#409EFF">已入库</span>`,
            `<span style="color:${this.getColor(-2)}">距交货-2天</span>`,
          ],
          [
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质列表</span>`,
            `<span style="color:#409EFF">已入库</span>`,
            `<span style="color:${this.getColor(2)}">距交货2天</span>`,
          ],
          [
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质列表</span>`,
            `<span style="color:#409EFF">已入库</span>`,
            `<span style="color:${this.getColor(0)}">距交货0天</span>`,
          ],
          [
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质列表</span>`,
            `<span style="color:#409EFF">已入库</span>`,
            `<span style="color:${this.getColor(0)}">距交货0天</span>`,
          ],
        ],
      },
    };
  },
  props: {},
  created() {},
  mounted() {},

  methods: {
    getColor(val) {
      if (val == 0) {
        return "#fee588";
      } else if (val < 0) {
        return "#F56C6C";
      } else {
        return "#409EFF";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-table-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 25vh;
  #chart-table {
    height: calc(100% - 30px);
    background: transparent;
    padding: 0 20px;
  }
}
</style>


